import { render, staticRenderFns } from "./SecuritySituationRecordList.vue?vue&type=template&id=2bbe6dbc&"
import script from "./SecuritySituationRecordList.vue?vue&type=script&lang=js&"
export * from "./SecuritySituationRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports